import { createSlice } from "@reduxjs/toolkit";
// import instance from "../../api/api.js";

export const spinnerReducer = createSlice({
  name: "loading",
  initialState: {
    isLoading: false,
  },
  reducers: {
    handleSpinnerLoading: (state, action) => {
      return {
        ...state,
        isLoading: action.payload,
      };
    },
  },
});

export const { handleSpinnerLoading } = spinnerReducer.actions;
export default spinnerReducer.reducer;
